import axios from 'axios';
import { jsPDF } from 'jspdf';
import React, { useEffect, useState } from 'react';
import { Button, Form, Modal } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import Main from '../components/custom/Main';
import PageContainer from '../components/custom/PageContainer';
import { apiUrl } from '../config';
import { BranchType, fetchBranch } from '../redux/actions/branchActions';
import { StoreState } from '../redux/reducers';
import { AppDispatch } from '../redux/store';

const StudentPdfForm: React.FC = () => {
    const dispatch = useDispatch<AppDispatch>();
    const branchList = useSelector<StoreState, BranchType[]>(state => state.branch);
    const [selectedBranch, setSelectedBranch] = useState<string>('');
    const [showModal, setShowModal] = useState(true);
    const [courseList, setCourseList] = useState<any[]>([]);

    useEffect(() => {
        dispatch(fetchBranch());
    }, [dispatch]);

    useEffect(() => {
        if (selectedBranch) {
            axios.get(`${apiUrl}/course/?branchId=${selectedBranch}`)
                .then(response => {
                    setCourseList(response.data.data);
                })
                .catch(error => console.log(error));
        }
    }, [selectedBranch]);

    const generatePdfForm = () => {
        const doc = new jsPDF();

        // Add title
        doc.setFontSize(18);
        doc.text('STUDENT ADMISSION FORM', 105, 15, { align: 'center' });

        // Add branch info
        const selectedBranchObj = branchList.find(b => b.id.toString() === selectedBranch);
        doc.setFontSize(12);
        doc.text(`${selectedBranchObj?.name || ''}`, 14, 25);

        // Add form fields
        let yPosition = 40;

        // Personal Information Section
        doc.setFontSize(14);
        doc.text('PERSONAL INFORMATION', 14, yPosition);
        yPosition += 10;

        doc.setFontSize(10);
        doc.text('Admission Number: ____________', 14, yPosition);
        doc.text('Register Number: ____________', 100, yPosition);
        yPosition += 8;

        doc.text('Admission Date: ____/____/____', 14, yPosition);
        doc.text('Batch: ____________', 100, yPosition);
        yPosition += 8;

        doc.text('Name: _________________________________________________', 14, yPosition);
        yPosition += 8;

        doc.text('Date of Birth: ____/____/____', 14, yPosition);
        doc.text('Gender: □ Male □ Female □ Transgender', 110, yPosition);
        yPosition += 8;

        doc.text('Course: _________________________________________________', 14, yPosition);
        yPosition += 8;

        doc.text('Current Semester: ____________', 14, yPosition);
        yPosition += 10;

        // Family Information Section
        doc.setFontSize(14);
        doc.text('FAMILY INFORMATION', 14, yPosition);
        yPosition += 10;

        doc.setFontSize(10);
        doc.text('Father\'s Name: _________________________________________________', 14, yPosition);
        yPosition += 8;

        doc.text('Father\'s Occupation: _________________________________________________', 14, yPosition);
        yPosition += 8;

        doc.text('Mother\'s Name: _________________________________________________', 14, yPosition);
        yPosition += 8;

        doc.text('Mother\'s Occupation: _________________________________________________', 14, yPosition);
        yPosition += 8;

        doc.text('Annual Income: ₹ ____________', 14, yPosition);
        yPosition += 10;

        // Contact Information Section
        doc.setFontSize(14);
        doc.text('CONTACT INFORMATION', 14, yPosition);
        yPosition += 10;

        doc.setFontSize(10);
        doc.text('Phone Number: ____________', 14, yPosition);
        doc.text('WhatsApp Number: ____________', 110, yPosition);
        yPosition += 8;

        doc.text('Email: _________________________________________________', 14, yPosition);
        yPosition += 8;

        doc.text('Aadhar Number: ____________', 14, yPosition);
        doc.text('EMIS/UMIS Number: ____________', 110, yPosition);
        yPosition += 10;

        // Address Section
        doc.setFontSize(14);
        doc.text('ADDRESS INFORMATION', 14, yPosition);
        yPosition += 10;

        doc.setFontSize(10);
        doc.text('Present Address:', 14, yPosition);
        yPosition += 8;
        doc.text('________________________________________________________________', 14, yPosition);
        yPosition += 8;
        doc.text('________________________________________________________________', 14, yPosition);
        yPosition += 8;
        doc.text('________________________________________________________________', 14, yPosition);
        yPosition += 10;

        doc.text('Permanent Address:', 14, yPosition);
        yPosition += 8;
        doc.text('________________________________________________________________', 14, yPosition);
        yPosition += 8;
        doc.text('________________________________________________________________', 14, yPosition);
        yPosition += 8;
        doc.text('________________________________________________________________', 14, yPosition);
        yPosition += 10;

        // Educational Qualifications Section
        // doc.setFontSize(14);
        // doc.text('EDUCATIONAL QUALIFICATIONS', 14, yPosition);
        // yPosition += 10;

        // // Create a table for qualifications
        // autoTable(doc, {
        //     startY: yPosition,
        //     head: [['Qualification', 'Board/University', 'Year of Passing', 'Total Marks', 'Secured Marks']],
        //     body: [
        //         ['', '', '', '', ''],
        //         ['', '', '', '', ''],
        //         ['', '', '', '', '']
        //     ],
        //     margin: { left: 14 },
        //     styles: { fontSize: 8 }
        // });

        // Add photo space
        doc.rect(160, 10, 40, 40);
        doc.text('Passport Size Photo', 180, 30, { align: 'center' });

        // Add signature space
        doc.text('Student Signature: ____________', 20, 280);
        doc.text('Parent/Guardian Signature: ____________', 110, 280);

        // Save the PDF
        doc.save(`Student_Admission_Form_${selectedBranchObj?.name || 'Branch'}.pdf`);
    };

    const handleGenerate = () => {
        if (selectedBranch) {
            setShowModal(false);
            generatePdfForm();
        }
    };

    return (
        <Main>
            <PageContainer title="Student View">
                <div>
                    <Modal show={showModal} onHide={() => setShowModal(false)} centered>
                        <Modal.Header closeButton>
                            <Modal.Title>Generate Student Admission Form</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <Form.Group controlId="branchSelect">
                                <Form.Label>Select Branch</Form.Label>
                                <Form.Control
                                    as="select"
                                    value={selectedBranch}
                                    onChange={(e) => setSelectedBranch(e.target.value)}
                                >
                                    <option value="">Select Branch</option>
                                    {branchList?.map((branch) => (
                                        <option key={branch.id} value={branch.id}>
                                            {branch.name}
                                        </option>
                                    ))}
                                </Form.Control>
                            </Form.Group>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={() => setShowModal(false)}>
                                Close
                            </Button>
                            <Button variant="primary" onClick={handleGenerate} disabled={!selectedBranch}>
                                Generate Form
                            </Button>
                        </Modal.Footer>
                    </Modal>

                    <div style={{ padding: '20px', textAlign: 'center' }}>
                        <h3>Student Admission Form Generator</h3>
                        <p>Select a branch to generate the PDF admission form</p>
                        <Button variant="primary" onClick={() => setShowModal(true)}>
                            Select Branch
                        </Button>
                    </div>
                </div>
            </PageContainer>
        </Main>
    );
};

export default StudentPdfForm;